import elves from '../../icons/elves.png';
import './Santa.css';

export default function SantaAfterXmas() {
  return (
    <div className="santa-screen">
      <div className="santa-card">
        <img src={elves} alt="Elves" className="santa-icon" />
        <p className="santa-message">Santa and the elves are wishing you Merry Christmas</p>
      </div>
    </div>
  );
}
